import { Appearance, ProductType } from '@/types';
import { compareColors } from '@/utils/colors/compareColors';

export const getClosestAppearance = (productType: ProductType, appearance: Appearance) => {
  const currentColor = appearance.colors[0].value;
  let minDistance = Number.POSITIVE_INFINITY;
  let closestAppearance: Appearance | undefined;

  for (const appearance of productType.appearances) {
    const distance = compareColors(currentColor, appearance.colors[0].value);
    if (distance < minDistance) {
      minDistance = distance;
      closestAppearance = appearance;
    }
  }

  return closestAppearance;
};
